import { render, staticRenderFns } from "./UISelect.vue?vue&type=template&id=0366a6aa&scoped=true"
import script from "./UISelect.vue?vue&type=script&lang=js"
export * from "./UISelect.vue?vue&type=script&lang=js"
import style0 from "./UISelect.vue?vue&type=style&index=0&id=0366a6aa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366a6aa",
  null
  
)

export default component.exports